export default "__VITE_ASSET__AO9v4wmn__"